import { ConfirmacaoDaAcao } from './moldura-da-acao';

import cardIcon from 'assets/img/card-plus.svg';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

/** Pergunta do Reconhecer+ antes de promover ou conceder selo com bônus. */
export default function ModalBonus({ onClose, onConfirm }: Props) {
  return (
    <ConfirmacaoDaAcao
      title="Reconhecer+"
      illustration={<img className="block w-10" src={cardIcon} alt="" />}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <p className="m-0">Você está prestes a usar o seu Reconhecer+.</p>
      <p className="m-0">Deseja confirmar essa ação?</p>
    </ConfirmacaoDaAcao>
  );
}
